import { getOwner } from '@ember/application';
import type Owner from '@ember/owner';
import RouterService from '@ember/routing/router-service';

export type RouterServiceWithLegacyTransitionTo = RouterService & {
  legacyTransitionTo: RouterService['transitionTo'];
};

/**
 * This initializer reopens the RouterService to add a legacyTransitionTo method.
 * This is a workaround to replace the this.transitionToRoute method on contollers that is removed in Ember 5.
 * The reason we don't use this.router.transitionTo directly is because of this bug: https://github.com/emberjs/ember.js/issues/19497.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function initialize() {
  RouterService.reopen({
    legacyTransitionTo(...args: Parameters<RouterService['transitionTo']>) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, ember/no-private-routing-service
      const router = (getOwner(this) as Owner).lookup(
        'router:main',
      ) as RouterService;

      return router.transitionTo(...args);
    },
  });
}

export default {
  initialize,
};
